import { type FieldContentsData } from 'javascripts/shared-types';
import { Project } from 'components/framework/models';
import Field, { type Flavor } from '../../Field';

export class StatusName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap', 'ideas'];
  }

  static subqueriesForModel() {
    return { project: Project.select(['isTeam']), workflowStatus: ['name'] };
  }

  get title() {
    return 'Status name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Under consideration' };
  }

  contentsForRecord(record): FieldContentsData {
    if (!record.project?.isTeam && record.workflowStatus) {
      return { text: record.workflowStatus.name };
    }

    return {};
  }
}
